import React, { useContext } from 'react'
import styles from './index.module.less'
import { IRights } from '../../types'

import context from '../../context'

interface IProps {
  selectHandle: (rights: IRights) => unknown
  coupons: IRights[]
}

const Item = (props: IRights & Partial<IProps> & { operateDesc: string }) => {
  const { currencySymbol, rightsAmt, operateDesc, selectHandle } = props
  return (
    <li className={styles.item} onClick={() => selectHandle(props)}>
      <div className={styles.cost}>
        <span className={styles.sign}>{currencySymbol}</span>
        <span className={styles.figure}>{rightsAmt}</span>
      </div>
      <div className={styles.desc}>{operateDesc}</div>
    </li>
  )
}

const Voucher = (props: IProps) => {
  const {
    voucher: { title, motion },
  } = useContext(context)
  const { selectHandle, coupons } = props

  return (
    <section className={styles.voucher}>
      <h2 className={styles.header}>
        <span>{title}</span>
      </h2>
      <ul className={styles.discount}>
        {coupons &&
          coupons.map((item) => (
            <Item
              key={item.rightsTemplateCode}
              selectHandle={selectHandle}
              {...item}
              operateDesc={motion}
            />
          ))}
      </ul>
    </section>
  )
}

export default Voucher
